import React from 'react';
import { Page, Card, Text, BlockStack } from '@shopify/polaris';

const PrivacyPolicy = () => {
  return (
    <Page title="Privacy Policy">
      <Card sectioned>
        <BlockStack gap="4">
          <Text as="h2" variant="headingLg">
            Privacy Policy for TrackingMania
          </Text>
          <Text as="p">
            <strong>Last Updated:</strong> July 26, 2025
          </Text>

          <Text as="h3" variant="headingMd">
            1. Introduction
          </Text>
          <Text as="p">
            Welcome to TrackingMania ("we," "our," or "us"). We are committed to protecting your privacy and the privacy of your customers. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you install our Shopify app and use our services.
          </Text>

          <Text as="h3" variant="headingMd">
            2. Information We Collect
          </Text>
          <Text as="p">
            We may collect the following types of information:
          </Text>
          <ul>
            <li><strong>Information from Merchants (You):</strong> When you install our app, we collect your name, email address, shop domain, and other contact details provided by Shopify. We also store information related to your app settings and billing.</li>
            <li><strong>Information from Your Customers:</strong> To provide our order tracking services, we access and store customer information related to their orders, including name, email, shipping address, and order details (products, prices, tracking numbers).</li>
          </ul>

          <Text as="h3" variant="headingMd">
            3. How We Use Your Information
          </Text>
          <Text as="p">
            We use the collected information to:
          </Text>
          <ul>
            <li>Provide, operate, and maintain our app's services.</li>
            <li>Send automated email notifications to your customers about their order status.</li>
            <li>Display order tracking information on a branded page.</li>
            <li>Communicate with you for support and billing purposes.</li>
            <li>Comply with legal obligations and Shopify's requirements.</li>
          </ul>

          <Text as="h3" variant="headingMd">
            4. Information Sharing and Disclosure
          </Text>
          <Text as="p">
            We do not sell or rent your personal information or your customers' information. We may share information with third-party service providers for essential functions like data hosting and email delivery, under strict confidentiality agreements. We may also disclose information if required by law.
          </Text>

          <Text as="h3" variant="headingMd">
            5. Data Security
          </Text>
          <Text as="p">
            We implement industry-standard security measures to protect your information from unauthorized access, alteration, or destruction. However, no method of transmission over the Internet is 100% secure.
          </Text>

          <Text as="h3" variant="headingMd">
            6. Data Retention
          </Text>
          <Text as="p">
            We retain your data for as long as you have the app installed. When you uninstall the app, we will delete your data in accordance with Shopify's requirements (typically within 30 days).
          </Text>

          <Text as="h3" variant="headingMd">
            7. Your Rights
          </Text>
          <Text as="p">
            You and your customers have the right to access, correct, or delete personal information. For any requests, please contact us at the email address below.
          </Text>
          
          <Text as="h3" variant="headingMd">
            8. Contact Us
          </Text>
          <Text as="p">
            If you have any questions about this Privacy Policy, please contact us at: cloudvilletech@gmail.com.
          </Text>
        </BlockStack>
      </Card>
    </Page>
  );
};

export default PrivacyPolicy;